import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
const SACRED_GEOMETRY = [
// Circle / Pulse
'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
// Triangle / Focus
'M12 2L2 20h20L12 2z',
// Diamond / Clarity
'M12 2L20 12L12 22L4 12L12 2z',
// Star / Energy
'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
// Spiral / Flow
'M12 4a8 8 0 0 1 0 16a6 6 0 0 0 0-12a4 4 0 0 1 0 8a2 2 0 0 0 0-4'];
const COLORS = ['#a78bfa', '#c084fc', '#d8b4fe', '#D4AF37', '#F9E29C', '#e9d5ff'];
export function FloatingEnergySymbols() {
  const symbols = useMemo(() => {
    return Array.from({
      length: 18
    }).map((_, i) => {
      const isEdge = Math.random() > 0.4;
      const leftPos = isEdge ? Math.random() > 0.5 ? Math.random() * 15 : 85 + Math.random() * 15 : Math.random() * 100;
      return {
        id: `floating-energy-${i}`,
        path: SACRED_GEOMETRY[i % SACRED_GEOMETRY.length],
        left: `${leftPos}%`,
        top: `${Math.random() * 100}%`,
        size: Math.random() * 60 + 30,
        color: COLORS[i % COLORS.length],
        duration: Math.random() * 30 + 25,
        delay: Math.random() * 15,
        driftX: (Math.random() - 0.5) * 40,
        driftY: (Math.random() - 0.5) * 60,
        rotateRange: (Math.random() - 0.5) * 20
      };
    });
  }, []);
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-[3]" data-id="element-225" data-mp="395f6uc0l4ju6">
      {symbols.map(s => <motion.svg key={s.id} viewBox="0 0 24 24" fill="none" stroke={s.color} strokeWidth="0.4" strokeLinecap="round" strokeLinejoin="round" className="absolute" style={{
      left: s.left,
      top: s.top,
      width: s.size,
      height: s.size
    }} initial={{
      opacity: 0,
      rotate: 0
    }} animate={{
      opacity: [0, 0.05, 0.05, 0],
      x: [0, s.driftX, 0],
      y: [0, s.driftY, 0],
      rotate: [0, s.rotateRange, -s.rotateRange, 0]
    }} transition={{
      duration: s.duration,
      repeat: Infinity,
      delay: s.delay,
      ease: 'easeInOut',
      times: [0, 0.3, 0.7, 1]
    }} data-id="element-226" data-mp="3486ks0cbfvnn">
          <path d={s.path} data-id="element-227" data-mp="5hdsxtp9yqrj" />
        </motion.svg>)}
    </div>;
}